import Vue from "vue";
import Router from "vue-router";
import store from "../helper/store";
import Home from "../components/dashboard/Home.vue";
import Comission from "../components/dashboard/Comission.vue";
import Transaction from "../components/dashboard/Transaction.vue";
import Settings from "../components/dashboard/Settings.vue";
import About from "../components/dashboard/About.vue";
import Login from "../components/dashboard/Login.vue";
import Secure from "../components/dashboard/Secure.vue";
import Register from "../components/dashboard/Register.vue";
import NotFoundDashbaord from "../components/dashboard/NotFoundDashboard.vue";
import NotFoundUrl from "../components/dashboard/NotFoundUrl.vue";
//Wedding page
import Wedding from "../components/wedding/wedding.vue";

Vue.use(Router);

let router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			name: "home",
			component: Home,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/comission",
			name: "comission",
			component: Comission,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/transaction",
			name: "transaction",
			component: Transaction,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/settings",
			name: "settings",
			component: Settings,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/wedding",
			name: "wedding",
			component: Wedding,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/not-found",
			name: "not-found",
			component: NotFoundDashbaord,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/notfound",
			name: "notfound",
			component: NotFoundUrl,
		},
		{
			path: "/login",
			name: "login",
			component: Login,
		},
		{
			path: "/register",
			name: "register",
			component: Register,
		},
		{
			path: "/secure",
			name: "secure",
			component: Secure,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/about",
			name: "about",
			component: About,
			meta: {
				requiresAuth: true,
			},
		},
	],
});

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			next();
			return;
		} else {
			next("/login");
			return;
		}
	} else {
		if (store.getters.isLoggedIn) {
			//router.replace({ path: "/not-found" });
			next("/not-found");
			return;
		}
		next();
		return;
	}
});

export default router;
